import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_indications_map.breadcrumb.indications_map_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_indications_map.breadcrumb.indications_map_label2'),
  },
];
